import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { PostQueueComment } from 'domain/usecases';
import { RemotePostQueueComment } from 'data/usecases/queue/remote-post-queue-comment';

export const makeRemotePostQueueComment = (queueId: string): PostQueueComment => {
  return new RemotePostQueueComment(
    makeApiUrl(`/queue/requests/${queueId}/comment`),
    makeAuthorizeHttpClientDecorator()
  );
};
